import { c as _c } from "react/compiler-runtime";
import { getHostedUserAuthMethodsQueryKey } from '@onefootprint/fetch-hosted';
import type { ActionKind } from '@onefootprint/request-types';
import { Button, Form, PageShell } from '@onefootprint/ui';
import { createFileRoute, getRouteApi, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { UpdateVerify } from '@/idv2/features/auth-methods/update-verify';
import { getLogger } from '@/idv2/utils/logger';
const {
  logInfo
} = getLogger({
  name: 'idv2',
  location: 'auth-methods-update-phone'
});
const parentRoute = getRouteApi('/auth-methods');
const searchSchema = z.object({
  actionKind: z.enum(['add_primary', 'replace']).catch('add_primary')
});
export const Route = createFileRoute('/auth-methods/update-phone')({
  component: UpdatePhone,
  validateSearch: searchSchema
});
type PhoneFormData = {
  phone: string;
};
function UpdatePhone() {
  const $ = _c(45);
  const navigate = useNavigate();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "authMethods"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t,
    i18n
  } = useTranslation("idv2", t0);
  const {
    actionKind
  } = Route.useSearch();
  const {
    token
  } = parentRoute.useLoaderData();
  const {
    queryClient
  } = Route.useRouteContext();
  const locale = i18n.language === "es" ? "es-MX" : "en-US";
  const [screen, setScreen] = useState("collect");
  const [phone, setPhone] = useState("");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValues: {
        phone: ""
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const methods = useForm(t1);
  let t2;
  if ($[2] !== actionKind || $[3] !== t) {
    t2 = actionKind === "replace" ? t(_temp) : t(_temp2);
    $[2] = actionKind;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const title = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = data => {
      setPhone(data.phone);
      setScreen("verify");
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSubmit = t3;
  let t4;
  if ($[6] !== navigate || $[7] !== queryClient || $[8] !== token) {
    t4 = () => {
      logInfo("Phone updated");
      queryClient.invalidateQueries({
        queryKey: getHostedUserAuthMethodsQueryKey({
          headers: {
            "X-Fp-Authorization": token
          }
        })
      });
      navigate({
        to: "/auth-methods"
      });
    };
    $[6] = navigate;
    $[7] = queryClient;
    $[8] = token;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleSuccess = t4;
  if (screen === "verify" && phone) {
    const t5 = actionKind as ActionKind;
    let t6;
    if ($[10] !== handleSuccess || $[11] !== phone || $[12] !== t5 || $[13] !== title || $[14] !== token) {
      t6 = <UpdateVerify token={token} challengeKind="sms" actionKind={t5} contactValue={phone} title={title} onSuccess={handleSuccess} />;
      $[10] = handleSuccess;
      $[11] = phone;
      $[12] = t5;
      $[13] = title;
      $[14] = token;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  let t5;
  if ($[16] !== t) {
    t5 = t(_temp3);
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== methods) {
    t6 = methods.handleSubmit(handleSubmit);
    $[18] = methods;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t) {
    t7 = t(_temp4);
    $[20] = t;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t) {
    t8 = t(_temp5);
    $[22] = t;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t8) {
    t9 = {
      required: t8
    };
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== locale || $[27] !== t7 || $[28] !== t9) {
    t10 = <div className="w-full"><Form.Tel label={t7} name="phone" locale={locale} rules={t9} /></div>;
    $[26] = locale;
    $[27] = t7;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t) {
    t11 = t(_temp6);
    $[30] = t;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11) {
    t12 = <Button type="submit" variant="primary" fullWidth={true} size="large">{t11}</Button>;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t12 || $[36] !== t6) {
    t13 = <form onSubmit={t6} className="flex flex-col gap-4 items-start w-full">{t10}{t12}</form>;
    $[34] = t10;
    $[35] = t12;
    $[36] = t6;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== methods || $[39] !== t13) {
    t14 = <FormProvider {...methods}>{t13}</FormProvider>;
    $[38] = methods;
    $[39] = t13;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t14 || $[42] !== t5 || $[43] !== title) {
    t15 = <PageShell title={title} subtitle={t5}>{t14}</PageShell>;
    $[41] = t14;
    $[42] = t5;
    $[43] = title;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  return t15;
}
function _temp6($_4) {
  return $_4.updatePhone.continue;
}
function _temp5($_3) {
  return $_3.updatePhone.requiredError;
}
function _temp4($_2) {
  return $_2.updatePhone.label;
}
function _temp3($_1) {
  return $_1.updatePhone.subtitle;
}
function _temp2($_0) {
  return $_0.updatePhone.addTitle;
}
function _temp($) {
  return $.updatePhone.replaceTitle;
}